import { render, staticRenderFns } from "./medicFrequency.vue?vue&type=template&id=46857479"
import script from "./medicFrequency.vue?vue&type=script&lang=js"
export * from "./medicFrequency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports